import { makeStyles } from '@fluentui/react-components';

export const useModalStyle = makeStyles({
  nameInput: {
    marginTop: '40px',
    marginBottom: '54px',
    width: '100%',
  },
  error: {
    fontSize: '14px',
    color: 'rgb(168, 0, 0)',
    marginTop: '-40px',
    marginBottom: '20px',
  },
});
